import { render } from "./CreateLeagueModal.vue?vue&type=template&id=7a5a7b30"
import script from "./CreateLeagueModal.vue?vue&type=script&lang=js"
export * from "./CreateLeagueModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__